<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.27 105.61">
    <path :fill="iconColor" d="M110.9,63.41h-5.3c0-8.4-2.8-16.1-7.5-22.4l-9.7,9.6c-2.2,2.2-5.8,2.2-8,0h0l-3.1-3.1c-1.1-1-1.5-2.5-1.3-4,.3-1.3.9-2.5,1.8-3.6,1.4-2,4.1-4.9,8.3-9.2-5.2-2.8-11.1-4.3-17.3-4.3h-5.3v-6.7c5.1-2.9,6.8-9.4,3.9-14.4-2.9-5.1-9.4-6.8-14.4-3.9-5.1,2.9-6.8,9.4-3.9,14.4.9,1.6,2.3,2.9,3.9,3.9v6.7h-5.3c-20.4,0-36.9,16.5-37,36.9h-5.3c-3,.1-5.4,2.4-5.4,5.3v15.8c0,2.9,2.4,5.3,5.3,5.3h5.3v5.3c0,5.8,4.7,10.6,10.6,10.6h73.9c5.8,0,10.5-4.7,10.6-10.5h0v-5.3h5.3c2.9,0,5.3-2.4,5.3-5.3v-15.8c0-2.9-2.4-5.3-5.3-5.3h-.1ZM40.6,79.41l-6.2-6.2-6.2,6.2-6.2-6.2,12.5-12.5,12.5,12.5-6.2,6.2h-.2ZM88.1,79.41l-6.2-6.2-6.2,6.2-6.2-6.2,12.5-12.5,12.5,12.5-6.2,6.2h-.2Z" />
    <path :fill="badgeColor" d="M122.5,45.01l-3.1,3.1c-.9.9-2.2.9-3.1,0l-26.2-26.1c-.7.2-1.5.3-2.2.3-4.9,0-8.8-3.9-8.8-8.8,0-1,.2-1.9.5-2.9l5.6,5.6,1.2-1.2,3.1-3.1,1.2-1.2-5.6-5.6c4.6-1.6,9.6.9,11.2,5.5.3.9.5,1.9.5,2.9,0,.7-.1,1.5-.3,2.2l26.1,26.2c.9.9.9,2.2,0,3.1M79.7,41.91c-.9.9-.9,2.2,0,3.1l3.1,3.1c.9.9,2.2.9,3.1,0l12-12-6.2-6.2s-12,12-12,12ZM118.7,4.81l-8.8,4.4v4.4l-4.8,4.8,4.4,4.4,4.8-4.8h4.4l4.4-8.8s-4.4-4.4-4.4-4.4Z" />
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: 'job_assistant'
      },
      iconColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.defaultIconColor }
      },
      badgeColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.primary }
      },
    }
  }
</script>
